import React from 'react';
import styled from 'styled-components';

import PopularDestinationsOffers from './components/PopularDestinationsOffers';
import PopularMetaregions from './components/PopularMetaregions';
import HotelsRelinking from './components/HotelsRelinking';
import NarrativeCards from './components/NarrativeCards';

import type { IRelinking } from './types';
import {
  COUNTRIES_DATA_TEST_ID,
  DATA_TEST_ID,
  HOTELS_DATA_TEST_ID,
  METAREGIONS_DATA_TEST_ID,
  NARRATIVE_DATA_TEST_ID,
  COUNTRIES_WITH_PRICES_DATA_TEST_ID,
} from './constants';

export const Relinking = (props: IRelinking): JSX.Element | null => {
  const {
    isMobile,
    isDefaultCountriesLinks,
    linkedHotels,
    narrativeCards,
    popularDestinationsOffers,
    popularMetaregionsOffers,
  } = props;

  const isPopularDestinationsOffers = !!popularDestinationsOffers?.length;
  const isPopularMetaregions = !!popularMetaregionsOffers?.length;
  const isHotelsRelinking = !!linkedHotels?.length;
  const isNarrativeCards = !!narrativeCards?.length;

  const isRelinkingDisabled =
    !isPopularDestinationsOffers &&
    !isPopularMetaregions &&
    !isHotelsRelinking &&
    !isNarrativeCards;

  if (isRelinkingDisabled) return null;

  return (
    <RelinkingWrapper $isMobile={isMobile} data-testid={DATA_TEST_ID}>
      {isPopularDestinationsOffers && (
        <Container
          data-testid={
            isDefaultCountriesLinks
              ? COUNTRIES_DATA_TEST_ID
              : COUNTRIES_WITH_PRICES_DATA_TEST_ID
          }
        >
          <PopularDestinationsOffers
            isMobile={isMobile}
            isDefault={isDefaultCountriesLinks}
            places={popularDestinationsOffers}
          />
        </Container>
      )}
      {isPopularMetaregions && (
        <Container data-testid={METAREGIONS_DATA_TEST_ID}>
          <PopularMetaregions
            isMobile={isMobile}
            places={popularMetaregionsOffers}
          />
        </Container>
      )}
      {isHotelsRelinking && (
        <Container data-testid={HOTELS_DATA_TEST_ID}>
          <HotelsRelinking isMobile={isMobile} linkedHotels={linkedHotels} />
        </Container>
      )}
      {isNarrativeCards && (
        <Container data-testid={NARRATIVE_DATA_TEST_ID}>
          <NarrativeCards
            isMobile={isMobile}
            narrativeCardsList={narrativeCards}
          />
        </Container>
      )}
    </RelinkingWrapper>
  );
};

const RelinkingWrapper = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile &&
    `
    margin-top: 20px;
    margin-left: -8px;
    padding: 8px;
  `}
`;

const Container = styled.div`
  color: #4d4d4d;
  font-family: Backpack;
  font-size: 14px;
  line-height: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;
